// https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export function numberWithCommas(x: number|null): string {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
}

export function percentOfNumber(x: number, percent: number): number {
  return x * percent / 100;
}